export default "__VITE_ASSET__Cj07yDeX__"